<!-- Theme CSS -->
<link href="/assets/css/style.css" rel="stylesheet">
<link href="/fr/assets/css/style.css" rel="stylesheet">
<link href="/en/assets/css/style.css" rel="stylesheet">
<link href="/es/assets/css/style.css" rel="stylesheet">
<link href="/pt/assets/css/style.css" rel="stylesheet">
<link href="/ko/assets/css/style.css" rel="stylesheet">
<app-header></app-header>
<router-outlet></router-outlet>



// WEBPACK FOOTER //
// ./src/app/introduction/introduction.component.html